import { QuadraticWidgetConfig } from '../quadratic-function.model';
import { EXPLORATION_PRESET } from './exploration.preset';
import { ROOT_CALCULATION_PRESET } from './root-calculation.preset';
import { TUTORING_PRESET } from './tutoring.preset';

export interface QuadraticPreset {
  id: string;
  title: string;
  description: string;
  config: QuadraticWidgetConfig;
}

export const QUADRATIC_PRESETS = {
  exploration: EXPLORATION_PRESET,
  tutoring: TUTORING_PRESET,
  rootCalculation: ROOT_CALCULATION_PRESET,
} as const;

export type QuadraticPresetId = keyof typeof QUADRATIC_PRESETS;
